import angularJsUtilitiesModule from "../angularJsUtilitiesModule";
import { EnvironmentUrls, CurrentUser } from "Roblox";

function friendsInfoService($document, $timeout, httpService, $filter, $q, localStorageService, localStorageNames) {
    "ngInject";
    var friendsInfoService = (function () {
        var callBacks = [];
        var friendsDict = {};
        var batchLimit = 100;
        var isFriendsDictLoaded = false;
        function friendsInfoService() {
            this.isInitialized = false;
        }

        function getPresences(userIds) {
            var promises = [];
            var startIndex = 0;
            var presenceApi = {
                url: EnvironmentUrls.presenceApi + "/v1/presence/users",
                retryable: true,
                withCredentials: true
            }
            var subUserIds = userIds.slice(startIndex, batchLimit);
            while (subUserIds.length > 0) {
                var params = {
                    userIds: subUserIds
                }
                promises.push(httpService.httpPost(presenceApi, params));
                startIndex++;
                subUserIds = userIds.slice(startIndex * batchLimit, startIndex * batchLimit + batchLimit);
            }

            return $q.all(promises);
        }

        function listenToPresenceUpdate(cachedData) {
            if (cachedData) {
                $document.on("Roblox.Presence.Update", function (event, args) {
                    if (args) {
                        $timeout(function () {
                            args.forEach(function (presence) {
                                var userId = presence.userId;
                                if (cachedData[userId]) {
                                    cachedData[userId].presence = presence;
                                }
                            });
                            localStorageService.saveDataByTimeStamp(localStorageNames.friendsDict, cachedData);
                        });
                    }
                });
            }
        }

        function removeFriendsDictCache() {
            $document.on("Roblox.Logout", function () {
                localStorageService.removeLocalStorage(localStorageNames.friendsDict);
            });
        }

        function canUseLocalStorageCache(cacheCriteria, options) {
            return cacheCriteria && cacheCriteria.isEnabled && CurrentUser && options.userId === CurrentUser.userId;
        }

        function getFriendsList(callback, cacheCriteria, options) {
            if (canUseLocalStorageCache(cacheCriteria, options)) {
                var cache = localStorageService.fetchNonExpiredCachedData(localStorageNames.friendsDict, cacheCriteria.expirationMS);
                if (cache) {
                    var cachedData = cache.data;
                    friendsDict = cachedData;
                    isFriendsDictLoaded = true;
                    listenToPresenceUpdate(cachedData);
                    var deferred = $q.defer();
                    deferred.resolve(cachedData);
                    return deferred.promise;
                }
            }
            var friendApi = {
                url: Roblox.EnvironmentUrls.friendsApi + "/v1/users/{userId}/friends",
                retryable: true,
                withCredentials: true
            }
            var profileUrl = "/users/{userId}/profile";
            friendApi.url = $filter("formatString")(friendApi.url, { 'userId': options.userId });
            return httpService.httpGet(friendApi)
                .then(function (result) {
                    var friends = result.data ? result.data : result;
                    var userIds = [];
                    angular.forEach(friends, function (friend) {
                        var friendUserId = friend.id;
                        userIds.push(friendUserId);
                        friend.profileUrl = $filter("formatString")(profileUrl, { userId: friendUserId });
                        friendsDict[friendUserId] = friend;
                    });
                    return getPresences(userIds)
                        .then(function (data) {
                            if (data && data.length > 0) {
                                var presences = [];
                                angular.forEach(data, function (item) {
                                    var presenceData = item.userPresences;
                                    presences = presences.concat(presenceData);
                                });
                                presences.forEach(function (presence) {
                                    friendsDict[presence.userId].presence = presence;
                                });
                            }

                            if (canUseLocalStorageCache(cacheCriteria, options)) {
                                localStorageService.saveDataByTimeStamp(localStorageNames.friendsDict, friendsDict);
                                listenToPresenceUpdate(friendsDict);
                                removeFriendsDictCache();
                            }

                            isFriendsDictLoaded = true;
                            return friendsDict;
                        });
                });
        }

        friendsInfoService.prototype.register = function (callback, cacheCriteria, userId) {
            if (typeof callback === "function") {
                callBacks.push(callback);
            }

            if (!this.isInitialized) {
                this.isInitialized = true;

                if (!userId && CurrentUser) {
                    userId = CurrentUser.userId;
                }

                getFriendsList(callBacks, cacheCriteria, { userId: userId })
                    .then(function (result) {
                        callBacks.forEach(function (func) {
                            func(result);
                        });
                    });
            } else if (isFriendsDictLoaded) {
                callback(friendsDict);
            }
        };

        return friendsInfoService;
    })();

    if (!Roblox.sharedFriendsService) {
        Roblox.sharedFriendsService = new friendsInfoService();
    }
    return Roblox.sharedFriendsService;
}

angularJsUtilitiesModule.factory("friendsInfoService", friendsInfoService);

export default friendsInfoService;